import { List, Map, Record } from "immutable";

export const COURSE_USER_SECTIONS_SPEC_TYPE: "course-user-sections" =
  "course-user-sections";

type UserId = string;
type SectionId = string;
type CourseId = string;

export type CourseUserSectionsSpecTypeJS = {
  courseId: CourseId;
  users: List<UserId>;
  sectionIds?: never;
};

export type CourseUserSectionsSpecType = {
  courseId: string | null;
  users: Map<UserId, List<SectionId>>;
  sectionIds?: never;
};

const defaultCourseUserSectionsSpec: CourseUserSectionsSpecType = {
  courseId: null,
  users: Map<UserId, List<SectionId>>()
};

export default class CourseUserSectionsSpec extends Record(
  defaultCourseUserSectionsSpec
) {}

export function fromJS(
  values: CourseUserSectionsSpecTypeJS
): CourseUserSectionsSpec {
  const { courseId, users } = values;
  return new CourseUserSectionsSpec({
    courseId,
    users: Map<UserId, List<SectionId>>().withMutations(mutableUsers => {
      return Object.keys(users).reduce(
        (acc, userId) => acc.set(userId, List((users as any)[userId])),
        mutableUsers
      );
    })
  });
}
